import { toaster } from '@/system/toaster'
import { useTranslation } from '@infraloop/i18n'
import { getErrorMesssage, registerUser } from '@infraloop/services'
import { useMutation } from '@tanstack/react-query'

/**
 * Owns the free-viewer-account registration. No access token is fetched: the caller is by
 * definition not signed in yet. A failure surfaces as a toast and leaves the form filled
 * in so the visitor can correct it and try again.
 */
const useRegisterUser = () => {
  // Hooks
  const { t } = useTranslation()

  /**
   * Create the account for the entered address. Name and company are only sent while
   * self-managed subscriptions are enabled, matching the fields the form collects.
   */
  const registerUserMutation = useMutation({
    mutationFn: ({ emailAddress, name, companyName }: { emailAddress: string; name?: string; companyName?: string }) =>
      registerUser(emailAddress, name, companyName),
    onError: (error) => {
      toaster.error({ description: getErrorMesssage(error, t) })
    },
  })

  return {
    registerUser: registerUserMutation.mutateAsync,
    isRegisteringUser: registerUserMutation.isPending,
  }
}

export default useRegisterUser
